import { SubItem } from "../SubItemTypes";

export const items: SubItem[] = [
  {
    description:
      "Junior Full-Stack Developer with 1 year of experience, currently actively seeking new opportunities. I have hands-on experience in the e-commerce domain, building and maintaining both frontend and backend features. My tech stack includes TypeScript, React, NestJS, and PostgreSQL. Motivated to grow professionally, deepen my technical expertise, and contribute to a strong development team.",
  },
];
